<template>
  <div class="about has_market_price">
    <Header />

    <div class="container mt-3">
      <!-- ABOUT US -->
      <div class="mb-5">
        <div class="row justify-content-center">
          <div class="col-12 my-4">
            <div class="row">
              <div class="col-12 col-lg-6">
                <h6 class="mb-3 text-center">About Us</h6>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="text-center px-2 mt-2">
              <p>
                Quick leap helps connect trades,
                <br />we are the first and foremost aggregated B2B market place
                providing access to markets for farmers, and the best graded
                quality produce at scale for the demand, while providing asset
                backed and secure investmentable trade opportunities.
              </p>
              <p>
                At the core of our solution are the small holder farmers we
                connect to markets, the trades we enable, and the businesses we
                help ensure have all of their raw material needs available all
                year round.
              </p>
              <p>
                Our goal is to help connect the food and raw materials that
                powers the productivity of people and companies around the
                world.
              </p>
              <p>
                We create systems and enduring relationships across board that
                enable us achieve a well-nourished and food secure world.
              </p>
            </div>
          </div>

          <div class="col-lg-6">
            <img
              class="img-fluid"
              src="/assets/images/world-food-940-940x625.jpg"
              alt="About us Quickleap"
            />
          </div>
        </div>
      </div>

      <!-- MEET THE TEAM -->
      <div class="mb-5">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="text-center">
              <h6 class="mt-5 mb-3">Meet the Team</h6>
              <div class="row justify-content-center">
                <div class="col-md-3 my-4">
                  <img
                    src="/assets/images/team/damien.jpg"
                    width="180px"
                    class="img-fluid rounded-circle mb-4"
                  />
                  <h6 class="mb-1 text-black font-weight-bold">Damion Udoh</h6>
                  Co-founder and <br />Chief executive
                  <div>
                    <a
                      href="https://www.linkedin.com/in/damion-udoh-9b60985b/"
                      class="mx-2"
                    >
                      <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                    </a>
                    <a href="mailto:info@quickleap.com" class="mx-2">
                      <font-awesome-icon :icon="['fas', 'envelope']" />
                    </a>
                  </div>
                </div>
                <div class="col-md-3 my-4">
                  <img
                    src="/assets/images/team/yakubu.jpg"
                    width="180px"
                    class="img-fluid rounded-circle mb-4"
                  />
                  <h6 class="mb-1 text-black font-weight-bold">
                    Yakubu Danjuma
                  </h6>
                  Team Lead <br />Field Operations
                  <div>
                    <a
                      href="https://www.linkedin.com/in/yakubu-danjuma-825437110/"
                      class="mx-2"
                    >
                      <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                    </a>
                    <a href="mailto:info@quickleap.com" class="mx-2">
                      <font-awesome-icon :icon="['fas', 'envelope']" />
                    </a>
                  </div>
                </div>

                <div class="col-md-3 my-4">
                  <img
                    src="/assets/images/team/stephen.jpg"
                    width="180px"
                    class="img-fluid rounded-circle mb-4"
                  />
                  <h6 class="mb-1 text-black font-weight-bold">
                    Stephen Agbayinta
                  </h6>
                  Team Lead <br />Trade execution
                  <div>
                    <a
                      href="https://www.linkedin.com/in/agbayinta-stephen-70167a118/"
                      class="mx-2"
                    >
                      <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                    </a>
                    <a href="mailto:info@quickleap.com" class="mx-2">
                      <font-awesome-icon :icon="['fas', 'envelope']" />
                    </a>
                  </div>
                </div>

                <div class="w-100"></div>

                <div class="col-md-3 my-4">
                  <img
                    src="/assets/images/team/adans.jpg"
                    class="img-fluid rounded-circle mb-4"
                    style="width:180px; height:180px;"
                  />
                  <h6 class="mb-1 text-black font-weight-bold">Adans Smart</h6>
                  Team Lead <br />Relationships
                  <div>
                    <a href="https://linkedin.com/" class="mx-2">
                      <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                    </a>
                    <a href="mailto:info@quickleap.com" class="mx-2">
                      <font-awesome-icon :icon="['fas', 'envelope']" />
                    </a>
                  </div>
                </div>

                <div class="col-md-3 my-4">
                  <img
                    src="/assets/images/team/soniya.jpg"
                    width="180px"
                    class="img-fluid rounded-circle mb-4"
                  />
                  <h6 class="mb-1 text-black font-weight-bold">
                    Soniya Hassan
                  </h6>
                  Financial Advisory
                  <div>
                    <a
                      href="https://www.linkedin.com/in/soniya-hassan-0b8aa84a/"
                      class="mx-2"
                    >
                      <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                    </a>
                    <a href="mailto:info@quickleap.com" class="mx-2">
                      <font-awesome-icon :icon="['fas', 'envelope']" />
                    </a>
                  </div>
                </div>

                <div class="col-md-3 my-4">
                  <img
                    src="/assets/images/team/sola.jpg"
                    width="180px"
                    class="img-fluid rounded-circle mb-4"
                  />
                  <h6 class="mb-1 text-black font-weight-bold">
                    Olusola Olawale
                  </h6>
                  Technical Advisory
                  <div>
                    <a
                      href="https://www.linkedin.com/in/olusola-olawale/"
                      class="mx-2"
                    >
                      <font-awesome-icon :icon="['fab', 'linkedin-in']" />
                    </a>
                    <a href="mailto:info@quickleap.com" class="mx-2">
                      <font-awesome-icon :icon="['fas', 'envelope']" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CONTACT US -->
      <div class="mb-5 mt-3">
        <div class="row justify-content-center align-items-center">
          <div class="col-lg-7">
            <img
              class="img-fluid"
              src="/assets/images/contact.jpg"
              alt="Contact Us"
            />
          </div>
          <div class="col-lg-5">
            <div class="pr-3 pt-2 text-center">
              <h6 class="mt-5 mb-3 text-dark">Contact Us</h6>
              <p>Hello@quickleapglobal.com</p>

              <p>
                No 3b Ayinde Sanni, Close,
                <br />Oregun Ikeja.
              </p>

              <p>For trade and related enquiries:</p>

              <p>tradeexecution@quickleapglobal.com</p>

              <p>+234 (0) 813 486 0483</p>

              <textarea
                rows="4"
                class="d-block border rounded-lg border-dark w-70 mx-auto px-3 py-4 mb-3 border-thick text-center"
                placeholder="Leave us a message/ 
  Send us a suggestion or Something you’ll like to see us do"
              ></textarea>
              <button
                class="btn btn-sm btn-black btn-pill mr-2 px-5 my-1"
                href="mailto::hello@quickleapglobal.com"
              >
                Send
              </button>
              <button class="btn btn-sm btn-black btn-pill px-4 my-1">
                Chat with us on Whatsapp
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <market-price />

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MarketPrice from "@/components/MarketPrice";
// import { PerfectScrollbar } from "vue2-div";

export default {
  metaInfo: {
    title: "Quickleap",
    titleTemplate: "%s | About Us",
    htmlAttrs: {
      lang: "en",
      amp: true
    }
  },
  components: {
    Header,
    Footer,
    MarketPrice
    // PerfectScrollbar
  }
};
</script>
